export default __webpack_public_path__ + "static/media/bx-chevron-left.a35e2a61.svg";